import Vue from "vue";
import Router from "vue-router";
import HomePage from "./components/homePage/HomePage";
import Books from "./components/books/Books";
import Reports from "./components/reports/Reports";
import Payments from "./components/payments/Payments";
import DistributionPoint from "./components/distributionPoint/DistributionPoint";
import Stock from "./components/stock/Stock";
import LibraryOrders from "./components/libraryOrders/LibraryOrders";
import SelectedBooks from "./components/selectedBooks/SelectedBooks";
import Courier from "./components/courier/Courier";


Vue.use(Router);

export default new Router({
    routes: [
        {path: '/', component: HomePage},
        {path: '/books', component: Books},
        {path: '/reports', component: Reports},
        {path: '/payments', component: Payments},
        {path: '/stock', component: Stock},
        {path: '/courier', component: Courier},
        {path: '/distributionPoint', component: DistributionPoint},
        {path: '/selectedBooks', component: SelectedBooks },
        {path: '/libraryOrders', component: LibraryOrders}
    ]
});